<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
  isWhatsAppType: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['edit', 'delete', 'duplicate', 'suppressions']);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleDuplicate = campaign => emit('duplicate', campaign);
const handleSuppressions = campaign => emit('suppressions', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :created-at="campaign.created_at"
      :updated-at="campaign.updated_at"
      :is-live-chat-type="isLiveChatType"
      :is-whats-app-type="isWhatsAppType"
      :template-params="campaign.template_params"
      :campaign-metrics="campaign.campaign_metrics"
      :suppression-count="campaign.suppression_count || 0"
      :variant-label="campaign.variant_label || ''"
      :lifecycle-permissions="campaign.lifecycle_permissions || {}"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @duplicate="handleDuplicate(campaign)"
      @suppressions="handleSuppressions(campaign)"
    />
  </div>
</template>
